import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = { class: "bg-carte p-5" }
const _hoisted_3 = { class: "s20" }
const _hoisted_4 = { class: "flex gap-5" }
const _hoisted_5 = { class: "s10_mobile" }
const _hoisted_6 = {
  key: 0,
  class: "card-carte"
}
const _hoisted_7 = { class: "card-carte-floating" }
const _hoisted_8 = { class: "s20" }
const _hoisted_9 = { class: "flex align-items-center gap-2" }
const _hoisted_10 = { class: "secondary-font text-6xl" }
const _hoisted_11 = { class: "card-carte-floating-bottom" }
const _hoisted_12 = { class: "s10 secondary-font font-bold" }
const _hoisted_13 = { class: "s10 flex-right align-items-center gap-2" }
const _hoisted_14 = { class: "secondary-font font-bold" }
const _hoisted_15 = {
  key: 1,
  class: "card-carte",
  style: {"opacity":"0.3"}
}
const _hoisted_16 = { class: "s10_mobile" }
const _hoisted_17 = {
  key: 0,
  class: "card-carte-verso"
}
const _hoisted_18 = { class: "flex-center gap-5 mt-5" }
const _hoisted_19 = { class: "btn-supra lg black flex-center flex-col align-items-center" }
const _hoisted_20 = { class: "text-grey-700" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "s11_mobile flex-center gap-5" }
const _hoisted_23 = { class: "w-35 px-1" }
const _hoisted_24 = { class: "w-65" }
const _hoisted_25 = { class: "secondary-font font-semibold text-grey-700 mb-2" }
const _hoisted_26 = { class: "secondary-font font-semibold text-grey-800 mb-2" }
const _hoisted_27 = { class: "s9_mobile" }
const _hoisted_28 = {
  class: "h-20 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_29 = { class: "widget-floating px-5 py-0 flex-left" }
const _hoisted_30 = { class: "w-50 text-sm" }
const _hoisted_31 = { class: "w-50 text-sm text-right font-bold" }
const _hoisted_32 = {
  key: 0,
  class: "flex-center gap-3 mt-4"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 1,
  class: "s20 flex gap-3 mb-6"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 2,
  class: "s20"
}
const _hoisted_37 = { class: "s13 mt-2" }
const _hoisted_38 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_39 = { class: "secondary-font font-semibold text-sm text-grey-600 mb-2" }
const _hoisted_40 = {
  key: 0,
  class: "text-grey-600 mb-4"
}
const _hoisted_41 = {
  key: 3,
  class: "flex-center py-7"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Doughnut = _resolveComponent("Doughnut")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.selectedCarte)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "secondary-font font-bold mb-3" }, "Solde utilisable", -1)),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("h1", _hoisted_10, _toDisplayString(_ctx.showBalance ? _ctx.formatAmount(_ctx.selectedCarte.solde) : '*** ***'), 1),
                        _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "secondary-font text-4xl mt-2" }, "F", -1)),
                        _createElementVNode("div", {
                          class: "mt-2 ml-2 cursor-pointer",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showBalance = !_ctx.showBalance))
                        }, [...(_cache[1] || (_cache[1] = [
                          _createElementVNode("img", {
                            src: "/public/icons/icon-eye-off.svg",
                            class: "size-medium icon-white",
                            alt: ""
                          }, null, -1)
                        ]))])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("h5", _hoisted_12, _toDisplayString(_ctx.selectedCarte.numeroMasque || ''), 1),
                        _createElementVNode("div", _hoisted_13, [
                          _cache[3] || (_cache[3] = _createElementVNode("img", {
                            src: "/public/icons/icon-edit.svg",
                            class: "size-medium icon-white",
                            alt: ""
                          }, null, -1)),
                          _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.selectedCarte.alias || _ctx.selectedCarte.type || 'Carte'), 1)
                        ])
                      ])
                    ])
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("img", {
                    src: "/public/images/carte_coop_light.png",
                    class: "card-carte-img",
                    alt: "Carte"
                  }, null, -1))
                ]))
              : (!_ctx.loading && _ctx.cartes.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[6] || (_cache[6] = [
                    _createStaticVNode("<div class=\"card-carte-floating\" data-v-bbd026f4><div class=\"s20\" data-v-bbd026f4><h5 class=\"secondary-font font-bold mb-3\" data-v-bbd026f4>Solde utilisable</h5><div class=\"flex align-items-center gap-2\" data-v-bbd026f4><h1 class=\"secondary-font text-6xl\" data-v-bbd026f4>0</h1><h2 class=\"secondary-font text-4xl mt-2\" data-v-bbd026f4>F</h2></div><div class=\"card-carte-floating-bottom\" data-v-bbd026f4><h5 class=\"s10 secondary-font font-bold\" data-v-bbd026f4>Aucune carte</h5></div></div></div><img src=\"/public/images/carte_coop_light.png\" class=\"card-carte-img\" alt=\"\" data-v-bbd026f4>", 2)
                  ]))]))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.selectedCarte)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("div", { class: "card-carte-floating right-bottom" }, null, -1),
                  _createElementVNode("img", {
                    src: "/public/images/carte_coop_verso.png",
                    class: "card-carte-img",
                    alt: "Carte verso"
                  }, null, -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[9] || (_cache[9] = _createStaticVNode("<button class=\"btn-supra lg black flex-center flex-col align-items-center opacity-3\" disabled data-v-bbd026f4><div class=\"btn-supra-show-set btn-supra-animate mb-3\" data-v-bbd026f4><div class=\"btn-supra-show px-2\" data-v-bbd026f4><img src=\"/public/icons/icon-scan.svg\" class=\"btn-supra-icon icon-white\" alt=\"\" data-v-bbd026f4></div></div><span class=\"text-grey-700\" data-v-bbd026f4>Scanner</span></button><button class=\"btn-supra lg black flex-center flex-col align-items-center opacity-3\" disabled data-v-bbd026f4><div class=\"btn-supra-show-set btn-supra-animate mb-3\" data-v-bbd026f4><div class=\"btn-supra-show px-2\" data-v-bbd026f4><img src=\"/public/icons/icon-recharger.svg\" class=\"btn-supra-icon icon-white\" alt=\"\" data-v-bbd026f4></div></div><span class=\"text-grey-700\" data-v-bbd026f4>Recharger</span></button><button class=\"btn-supra lg black flex-center flex-col align-items-center opacity-3\" disabled data-v-bbd026f4><div class=\"btn-supra-show-set btn-supra-animate mb-3\" data-v-bbd026f4><div class=\"btn-supra-show\" data-v-bbd026f4><img src=\"/public/icons/icon-souscription.svg\" class=\"btn-supra-icon icon-white\" alt=\"\" data-v-bbd026f4></div></div><span class=\"text-grey-700\" data-v-bbd026f4>Répartition</span></button>", 3)),
          _createElementVNode("button", _hoisted_19, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "btn-supra-show-set btn-supra-animate mb-3" }, [
              _createElementVNode("div", { class: "btn-supra-show" }, [
                _createElementVNode("img", {
                  src: "/public/icons/icon-verrouillage.svg",
                  class: "btn-supra-icon icon-white",
                  alt: ""
                })
              ])
            ], -1)),
            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.selectedCarte?.statut === 'blocked' ? 'Verrouillée' : 'Verrouiller'), 1)
          ])
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("hr", { class: "hr mt-6 mb-6 opacity-1" }, null, -1)),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "clear-both h-0" }, " ", -1)),
        (_ctx.selectedMois)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_Doughnut, {
                    data: _ctx.doughnutData,
                    options: _ctx.doughnutOptions
                  }, null, 8, ["data", "options"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "secondary-font font-semibold text-grey-600 mb-2" }, "Solde utilisé", -1)),
                  _createElementVNode("h2", _hoisted_25, _toDisplayString(_ctx.moisLabel(_ctx.selectedMois.mois)) + " " + _toDisplayString(_ctx.selectedMois.annee), 1),
                  _createElementVNode("h1", _hoisted_26, _toDisplayString(_ctx.formatAmount(_ctx.soldeUtilise)) + " F CFA", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedMois.stat, (cat, idx) => {
                  return (_openBlock(), _createElementBlock("div", { key: idx }, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.categorieLabel(cat.categorie_slug)) + "   " + _toDisplayString(Math.round(cat.pourcentage)) + "%", 1),
                        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.formatAmount(cat.total)) + " F", 1)
                      ]),
                      _createElementVNode("div", {
                        class: "h-100p flex align-items-center justify-content-right rounded-100 text-lg text-white",
                        style: _normalizeStyle({ width: cat.pourcentage + '%', backgroundColor: _ctx.getCategorieColor(cat.categorie_slug) })
                      }, null, 4)
                    ]),
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "clear-both h-7" }, " ", -1))
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.cartes.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartes, (carte, idx) => {
            return (_openBlock(), _createElementBlock("span", {
              key: carte.id,
              class: _normalizeClass(["btn sm", _ctx.selectedCarteIndex === idx ? 'light2' : 'light']),
              onClick: ($event: any) => (_ctx.selectCarte(idx))
            }, _toDisplayString(carte.alias || carte.bloc4), 11, _hoisted_33))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "clear-both h-20" }, " ", -1)),
    (_ctx.moisData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moisData, (m, idx) => {
            return (_openBlock(), _createElementBlock("span", {
              key: idx,
              class: _normalizeClass(["btn sm cursor-pointer", _ctx.selectedMoisIndex === idx ? 'light2' : 'light']),
              onClick: ($event: any) => (_ctx.selectedMoisIndex = idx)
            }, _toDisplayString(_ctx.moisLabel(m.mois)), 11, _hoisted_35))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedMois)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedMois.transactions, (tx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tx.id,
              class: "flex gap-6 mb-4"
            }, [
              _cache[14] || (_cache[14] = _createElementVNode("div", {
                class: "square-xl px-4 py-4",
                style: {"background-color":"rgba(0, 185, 172, 0.08)"}
              }, [
                _createElementVNode("img", {
                  src: "/public/icons/icon-trans-recharger.svg",
                  width: "100%",
                  class: "icon-neutral",
                  alt: ""
                })
              ], -1)),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("h6", _hoisted_38, _toDisplayString(tx.libelle), 1),
                _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.formatDateTransaction(tx.date)) + " - " + _toDisplayString(tx.reference), 1)
              ]),
              _createElementVNode("h5", {
                class: _normalizeClass(["s5 secondary-font text-right mt-2", tx.type === 'credit' ? 'text-green' : ''])
              }, _toDisplayString(tx.type === 'credit' ? '+' : '-') + _toDisplayString(_ctx.formatAmount(tx.montant)) + " F ", 3)
            ]))
          }), 128)),
          (_ctx.selectedMois.transactions.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, " Aucune transaction pour ce mois "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [...(_cache[15] || (_cache[15] = [
          _createElementVNode("p", { class: "secondary-font text-grey-600" }, "Chargement...", -1)
        ]))]))
      : _createCommentVNode("", true),
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "clear-both h-60" }, null, -1))
  ]))
}